import { render, staticRenderFns } from "./PlayCollapse.vue?vue&type=template&id=7d2fbfc4&scoped=true"
import script from "./PlayCollapse.vue?vue&type=script&lang=js"
export * from "./PlayCollapse.vue?vue&type=script&lang=js"
import style0 from "./PlayCollapse.vue?vue&type=style&index=0&id=7d2fbfc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2fbfc4",
  null
  
)

export default component.exports